// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createRole, deleteRole, getDetailRole, getListRole, updateRole } from './roleThunk';

export interface IRoleState {
  isRefreshRoleList: boolean;
}

export const initialState: IRoleState = {
  isRefreshRoleList: false,
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRefreshRoleList(state, action) {
      state.isRefreshRoleList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list role
    builder
      .addCase(getListRole.pending, (_state) => {})
      .addCase(getListRole.fulfilled, (_state) => {})
      .addCase(getListRole.rejected, (_state) => {});

    // GET: Get detail role
    builder
      .addCase(getDetailRole.pending, (_state) => {})
      .addCase(getDetailRole.fulfilled, (_state) => {})
      .addCase(getDetailRole.rejected, (_state) => {});

    // POST: Create role
    builder
      .addCase(createRole.pending, (_state) => {})
      .addCase(createRole.fulfilled, (state) => {
        state.isRefreshRoleList = true;
      })
      .addCase(createRole.rejected, (_state) => {});

    // PUT: Update  role
    builder
      .addCase(updateRole.pending, (_state) => {})
      .addCase(updateRole.fulfilled, (state) => {
        state.isRefreshRoleList = true;
      })
      .addCase(updateRole.rejected, (_state) => {});

    // DELETE: Delete role
    builder
      .addCase(deleteRole.pending, (_state) => {})
      .addCase(deleteRole.fulfilled, (state) => {
        state.isRefreshRoleList = true;
      })
      .addCase(deleteRole.rejected, (_state) => {});
  },
});

// Action
export const roleActions = roleSlice.actions;

// Selectors
// Reducer
const roleReducer = roleSlice.reducer;
export default roleReducer;
